import styled from 'styled-components';

export const StyledRazorpayChargesCard = styled.div(
  ({ theme }) => `
      background: linear-gradient(94deg, ${theme.colors.surface.background.gray.intense} 3.01%, ${theme.colors.feedback.background.information.subtle} 96.99%), ${theme.colors.surface.background.gray.moderate};  
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing[2]}px;
      padding: ${theme.spacing[4]}px;
      border-radius: ${theme.border.radius.small}px;
      margin: ${theme.spacing[2]}px;
    `,
);

export const StyledAmountCardWrapper = styled.div(
  ({ theme }) => `
      background: ${theme.colors.surface.background.gray.intense};
      display: flex;
      flex-direction: column;
      border-radius: ${theme.border.radius.medium}px;
      margin-bottom: ${theme.spacing[4]}px;
    `,
);
